import request from '@/utils/request'

export function getAreaTree () {
  return request({ url: '/sys/area/tree', method: 'get' })
}

export function listArea (params) {
  return request({ url: '/sys/area/list', method: 'get', params })
}

export function pageArea (params) {
  return request({ url: '/sys/area/page', method: 'get', params })
}

/** 从华住开放接口同步区域到 extra_area */
export function syncAreaFromHuazhu () {
  return request({ url: '/sys/area/sync-from-huazhu', method: 'post' })
}
